export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-popup/index.js